'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksFaqList,
  ComponentBlocksQuestionList,
  Enum_Componentshareddisplayoptions_Contentswidth,
} from '@/types';

import GlobalBlockRenderer from '../GlobalBlockRenderer/GlobalBlockRenderer';
import { FaqListPlainWithGrouping } from './FaqListPlainWithGrouping';
import { QuestionAnswer } from './QuestionAnswer';

export function FaqListWithGrouping({ props }: { props: ComponentBlocksFaqList }) {
  if (!props.FaqListStyle || props.FaqListStyle === 'Plain') {
    return <FaqListPlainWithGrouping props={props} />;
  }

  const questionGroups = (props.Questions as ComponentBlocksQuestionList[]).reduce(
    (acc, question) => {
      const key = question.Group || 'Ungrouped';
      if (!acc[key]) acc[key] = [];
      acc[key].push(question);
      return acc;
    },
    {} as Record<string, ComponentBlocksQuestionList[]>
  );

  return (
    <CustomBackground
      backgroundOptions={(props?.FaqListBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        {
          ...props?.FaqListDisplayOptions,
          ContentsWidth:
            props?.FaqListDisplayOptions?.ContentsWidth ??
            Enum_Componentshareddisplayoptions_Contentswidth.Wide,

          PaddingTop: props?.FaqListDisplayOptions?.PaddingTop ?? 'md',
          PaddingBottom: props?.FaqListDisplayOptions?.PaddingBottom ?? 'md',
          PaddingInline: props?.FaqListDisplayOptions?.PaddingInline ?? 'md',
        } as StrapiDisplayOptions
      }
      boxProps={{
        // @ts-expect-error - this does work, but types are not correct
        'data-component': 'FaqListWithGrouping',
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          textAlign: 'center',
          mb: 4,
          h2: {
            textAlign: 'center',
          },
        }}
      >
        <GlobalBlockRenderer content={props.Body || []} forceHeadingLevel={2} />
      </Box>

      {questionGroups &&
        Object.entries(questionGroups).map(([groupTitle, questions]) => (
          <Box sx={{ mb: 4 }} key={groupTitle}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              {groupTitle}
            </Typography>
            <Box
              sx={{
                '& > *': {
                  '&:nth-of-type(even)': {
                    ml: { xs: 4, sm: 6, md: 8 },
                  },
                  '&:nth-of-type(odd)': {
                    mr: { xs: 4, sm: 6, md: 8 },
                  },
                },
              }}
            >
              {questions &&
                questions.map((q) => (
                  <QuestionAnswer
                    key={`${q.id}-${q.Question}`}
                    {...(q as ComponentBlocksQuestionList)}
                  />
                ))}
            </Box>
          </Box>
        ))}
    </CustomBackground>
  );
}
